import { BoxV2 as Box, Button, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';

import { Modal } from '@/components';

interface AssetVerificationPendingModalProps {
  open?: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
}

const Title: FunctionComponent = ({ children }) => (
  <Box
    sx={{
      padding: '12px 0',
      color: 't.black80',
      fontWeight: 600,
      fontSize: 'H600',
      lineHeight: 'normal',
    }}
  >
    {children}
  </Box>
);

const Message: FunctionComponent = ({ children }) => (
  <Box
    sx={{
      paddingBottom: 'xs',
      color: 't.black80',
      fontWeight: 400,
      fontSize: 'H400',
      lineHeight: 'normal',
    }}
  >
    {children}
  </Box>
);

const Actions: FunctionComponent = ({ children }) => (
  <Flex
    sx={{
      flexDirection: 'row',
      alignItems: 'center',
      gap: '18px',
      padding: '30px 0',
    }}
  >
    {children}
  </Flex>
);

const AssetVerificationPendingModal: FunctionComponent<
  AssetVerificationPendingModalProps
> = ({ open, onCancel, onSubmit }) => (
  <Modal style={{ width: '483px' }} open={open}>
    <Title>Asset Verification Pending</Title>
    <Message>
      This asset has a pending asset verification. You may continue with
      registration, but its final status may be affected by the outcome.
    </Message>
    <Actions>
      <Button variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button onClick={onSubmit}>Continue</Button>
    </Actions>
  </Modal>
);

export default AssetVerificationPendingModal;
